<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let transporter = null;

    const dispatch = createEventDispatcher();

    const onCreate = () => {
        dispatch('create');
    }

    const onEdit = (obj) => {
        dispatch('edit', obj.id);
    }

    const onDelete = (obj) => {
        Alert.delete("Delete vehicle", `This will permanently delete vehicle "${obj.licence_no}".\nAre you sure?`, () => deleteVehicle(obj.id));
    }

    const deleteVehicle = (id) => {
        const onSuccess = result => {
            transporter.vehicles = transporter.vehicles.filter(x => x.id !== result);
            Notifier.showMessage("Vehicle deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                let message = [];

                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });

                Alert.warning("Delete vehicle", `Vehicle is associated with ${message.join(", ")}.\nYou can not delete this vehicle.`);
            }
        };

        R.handle(R.vehicle.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Vehicles
        <button class="btn btn-primary btn-sm py-1" on:click="{ onCreate }" disabled="{ transporter.id == 0 }">
            CREATE VEHICLE
        </button>
    </div>
    {#if transporter.id > 0}
        {#if transporter.vehicles.length}
            <table class="table table-list">
                <tbody>
                {#each transporter.vehicles as item}
                    <tr class="row-hover">
                        <td>
                            <div class="small">
                                { item.type.name }
                            </div>
                            <div class="is-link" class:not-active={ item.is_active < 1 }
                                  on:click="{ () => onEdit(item) }">
                                { item.licence_no }
                            </div>
                        </td>
                        <td class="button-column pointer" title="delete vehicle" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="panel-body panel-pad">
                Transporter has no vehicles.
            </div>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new transport company in order to add vehicles.
        </div>
    {/if}
</div>